<script lang="ts">
	import SignUpFormV2 from 'src/components/Profiles/SignUpFormV2.svelte';
	import { push } from 'svelte-spa-router';
</script>

<SignUpFormV2
	idPrefix="signup"
	showLangDropdown={false}
	on:registered={() => push('/login')}
	on:close={() => push('/login')}
/>
